import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../index';
import ProjectCard from './ProjectCard';
import ProjectFormModal from './ProjectFormModal';

function Profile({ dropDown, handleDropDownModal }) {
  const { 
    user,
    userID, 
    userCred, 
    authorized, 
    getUserProjects,
    createProject,
    updateProject,
    deleteProject,
    loading,
    error 
  } = useContext(AppContext);

  const [userProjects, setUserProjects] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalTwo, setModalTwo] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [localLoading, setLocalLoading] = useState(false);
  
  const [form, setForm] = useState({
    title: "",
    github: "",
    deployedLink: "",
    picture: "",
    gid: userID.userID,
    backendRepo: "",
    backendDeploy: "",
    creator: userCred?.additionalUserInfo?.profile?.name || user.name
  });
  
  const [formPut, setFormPut] = useState({
    _id: "",
    title: "",
    github: "",
    deployedLink: "",
    picture: "",
    gid: userID.userID,
    backendRepo: "",
    backendDeploy: "",
    creator: userCred?.additionalUserInfo?.profile?.name || user.name
  });
  
  const [formDelete, setFormDelete] = useState({ _id: "" });

  useEffect(() => {
    if (authorized && userID.userID) {
      loadUserProjects();
    }
  }, [authorized, userID.userID]);

  const loadUserProjects = async () => {
    try {
      const projects = await getUserProjects(userID.userID);
      setUserProjects(projects);
    } catch (err) {
      console.log("Error loading user projects:", err);
    }
  };

  const handleModalState = () => {
    setModal(!modal);
    if (modal) {
      resetForm();
    }
  };
  
  const handlePutModalState = () => {
    setModalTwo(!modalTwo);
  };
  
  const handleDeleteModalState = () => {
    setModalDelete(!modalDelete);
  };

  const editForm = (value) => {
    setForm(prev => ({ ...prev, ...value }));
  };
  
  const editFormTwo = (value) => {
    setFormPut(prev => ({ ...prev, ...value }));
  };

  const resetForm = () => {
    setForm({
      title: "",
      github: "",
      deployedLink: "",
      picture: "",
      gid: userID.userID,
      backendRepo: "",
      backendDeploy: "",
      creator: userCred?.additionalUserInfo?.profile?.name || user.name
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalLoading(true);
    
    try {
      await createProject(form);
    } catch (err) {
      console.log("Error creating project:", err);
    } finally {
      handleModalState();
      await loadUserProjects();
      setLocalLoading(false);
    }
  };
  
  const handlePutSubmit = async (e) => {
    e.preventDefault();
    setLocalLoading(true);
    
    try {
      await updateProject(formPut);
    } catch (err) {
      console.log("Error updating project:", err);
    } finally {
      handlePutModalState();
      await loadUserProjects();
      setLocalLoading(false);
    }
  };

  const handleDeleteSubmit = async (e) => {
    e.preventDefault();
    setLocalLoading(true);
    
    try {
      await deleteProject(formDelete._id);
      handleDeleteModalState();
      await loadUserProjects();
    } catch (err) {
      console.log("Error deleting project:", err);
    } finally {
      setLocalLoading(false);
    }
  };

  const handleEditProject = (project) => {
    setFormPut({
      _id: project._id,
      title: project.title,
      github: project.github,
      deployedLink: project.deployedLink,
      backendRepo: project.backendRepo || "",
      backendDeploy: project.backendDeploy || "",
      picture: project.picture,
      gid: project.gid,
      creator: project.creator
    });
    handlePutModalState();
  };

  const handleDeleteProject = (project) => {
    setFormDelete({ _id: project._id });
    handleDeleteModalState();
  };

  useEffect(() => {
    if (modal || modalTwo || modalDelete) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modal, modalTwo, modalDelete]);

  if (!authorized) {
    return (
      <div className="breach">
        <div className="breach-content">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="breach-icon">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
          <h2 className="breach-title">Sign in to view your dashboard</h2>
          <p className="breach-subtitle">Please log in to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-home font-change">
      <div className="container-new-project">
        <div></div>
        <div className="explore">My Projects</div>
        <div className="explore">
          <button onClick={handleModalState} className="new-project">
            New Project
          </button>
        </div>
      </div>
      
      {(loading || localLoading) && userProjects.length === 0 && (
        <div className="text-center text-gray-500 mt-10">
          Loading your projects...
        </div>
      )}
      
      {error && (
        <div className="text-center text-red-600 mt-10">
          {error}
        </div>
      )}
      
      {!loading && !localLoading && userProjects.length === 0 && (
        <div className="text-center text-gray-500 mt-10">
          You haven't created any projects yet. Click "New Project" to get started!
        </div>
      )}

      {/* Fixed Layout - Now matches Home Page exactly */}
      {userProjects.map((project, index) => (
        <ProjectCard
          key={project._id || index}
          project={project}
          allUsers={[]}
          dropDown={dropDown}
          setDropDown={handleDropDownModal}
          showActions={true}
          onEdit={() => handleEditProject(project)}
          onDelete={() => handleDeleteProject(project)}
          isOwner={true}
        />
      ))}

      <ProjectFormModal
        isOpen={modal}
        onClose={handleModalState}
        onSubmit={handleSubmit}
        form={form}
        onFormChange={editForm}
        title="Create New Project"
        submitText={localLoading ? "Creating..." : "Post"}
        loading={localLoading}
      />

      <ProjectFormModal
        isOpen={modalTwo}
        onClose={handlePutModalState}
        onSubmit={handlePutSubmit}
        form={formPut}
        onFormChange={editFormTwo}
        title="Update Project"
        submitText={localLoading ? "Updating..." : "Submit"}
        isEdit={true}
        loading={localLoading}
      />

      {modalDelete && (
        <div className="modal">
          <div onClick={handleDeleteModalState} className="overlay"></div>
          <div className="modal-content">
            <form onSubmit={handleDeleteSubmit}>
              <div className="delete-modal-question">
                Are you sure you want to delete this project? This action cannot be undone.
              </div>
              <div className="flex gap-2 mt-4" style={{display: 'flex', gap: '0.5rem', marginTop: '1rem', justifyContent: 'center'}}>
                <button 
                  type="submit"
                  className="btn-delete-project"
                  disabled={localLoading}
                >
                  {localLoading ? "Deleting..." : "Delete"}
                </button>
                <button 
                  type="button"
                  onClick={handleDeleteModalState} 
                  className="close-modal"
                  style={{position: 'static', padding: '0.25rem 0.5rem'}}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>             
        </div>
      )}
    </div>
  );
}

export default Profile;